import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render launch section for FAQ Page
 */
const LaunchSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="launch-section-component"
    >
      <AccordionV2
        testId="launch"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="When was SCA conceived? By whom?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 mt-4 px-6 py-4 pb-0">
          <p>
            The SCA was launched on 19 September 2005 as the umbrella awards for
            exemplary corporate governance practices for listed companies in
            Singapore.
          </p>

          <p>
            For the first eight years of the SCA, the event was organised by The
            Business Times (BT) and supported by Singapore Exchange (SGX) with
            several partners including:
          </p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>Institute of Singapore Chartered Accountants (ISCA);</li>
            <li>Singapore Institute of Directors (SID);</li>
            <li>Citigate Dewe Rogerson, i.MAGE;</li>
            <li>NUS Business School;</li>
            <li>Aon Hewitt;</li>
            <li>Egon Zehnder International;</li>
            <li>Investment Management Association of Singapore (IMAS);</li>
            <li>Securities Investor Association Singapore (SIAS);</li>
          </ul>

          <p>
            In 2014, ISCA and SID joined BT as co-organisers, and the Accounting
            and Corporate Regulatory Authority (ACRA) joined SGX to actively
            support the event.
          </p>

          <p>The current award partners are:</p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>Bain & Company;</li>
            <li>Deloitte;</li>
            <li>EY;</li>
            <li>Heidrick & Struggles Inc;</li>
            <li>KPMG;</li>
            <li>PwC;</li>
            <li>
              Centre for Governance and Sustainability, NUS Business School;
            </li>
            <li>Citigate Dewe Rogerson Singapore Pte Ltd;</li>
          </ul>
        </div>
      </AccordionV2>
    </div>
  );
};

export default LaunchSection;
